import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { utils } from '@cpc/comment-sdk-common';

export function useStyleType(options = {}) {
  const { getStyleType } = utils;
  const contentType = getStyleType();
  const { documentMeta } = useGlobalState();
  const styleType = documentMeta.styleType;

  /**
   * 一级文章页
   *  contentType为非空
   *  styleType存在对应值
   *
   * 全部评论页 && 二级回复页
   *  contentType: null
   *  styleType存在对应值为1
   *
   * 视频
   *  contentType: null
   *  styelType
   *    2是短视频，4是小视频
   */
  const isNotVideo = () => {
    return contentType || (styleType !== 2 && styleType !== 4);
  };

  return {
    isNotVideo,
  };
}
